import { render, staticRenderFns } from "./bible-study__Remove.vue?vue&type=template&id=76a40a06&scoped=true&lang=pug&"
import script from "./bible-study__Remove.vue?vue&type=script&lang=js&"
export * from "./bible-study__Remove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a40a06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
